import { appConfig } from "@/constants";
import { getRarityTierLevel } from "@/utils/rewards";
import { Box } from "@biom3/react";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useMemo } from "react";
import { useWeeklyRewards } from "./WeeklyRewardsProvider";

export const RewardKeysAnimation = () => {
  const {
    isCalculatePeriod,
    isFinalPeriod,
    sweepstakeTickets,
    isLoading,
    currentRarity,
  } = useWeeklyRewards();
  const { keyTransparency } = useFlags();

  const claimableTicket = sweepstakeTickets?.find(
    (ticket) => ticket.status === "claimable",
  );

  const spline = useMemo(() => {
    if (isCalculatePeriod || isFinalPeriod || claimableTicket) {
      const tierLevel = currentRarity
        ? getRarityTierLevel(currentRarity)
        : claimableTicket?.rarity
          ? getRarityTierLevel(claimableTicket.rarity)
          : 0;
      keyTransparency;
      return {
        url: `${appConfig.SPLINE_VIEWER}/T5erQ-DfxB5M7VSg?1d5c8b83-2300-4c3c-8e58-56b830fd6c1c=${tierLevel}`,
        size: "150%",
      };
    }
    return {
      url: `${appConfig.SPLINE_VIEWER}/qVZqky0jeoUqz3Dy`,
      size: "100%",
    };
  }, [
    isCalculatePeriod,
    isFinalPeriod,
    currentRarity,
    claimableTicket,
    keyTransparency,
  ]);

  return (
    <>
      <Box
        sx={{
          position: {
            default: "relative",
            xLarge: "absolute",
          },
          width: {
            default: "100%",
            xLarge: "50%",
          },
          height: {
            default: "200px",
            xLarge: "100%",
          },
          right: "0",
          bottom: {
            default: "0",
            xLarge: "auto",
          },
          top: {
            default: "auto",
            xLarge: "0",
          },
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "100%",
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {isLoading ? null : (
            <iframe
              src={spline?.url}
              title="IMX Keys Animation"
              width={spline?.size}
              height={spline?.size}
              style={{
                pointerEvents: "none",
                border: "none",
                objectFit: "contain",
                colorScheme: "auto",
                zIndex: -1,
              }}
              loading="eager"
            />
          )}
        </Box>
      </Box>
    </>
  );
};
